<template>
  <div id="about-ac">
    <!-- 奥创软件研究院 -->
    <div class="ac-school">
      <div class="title">奥创软件研究院</div>
      <div class="text-wrap">
        <p class="text">
奥创软件研究院是一家专注于技术研发的机构，目前已有多款成熟的软件产品，具备国内领先的软件产品系统开发技术，
        </p>
        <p class="text">目前专注于技术研发领域，为企业提供移动营销及管理解决方案。</p>
        <p class="text">
为了更好的服务广大客户，扩张技术研发团队的规模，在核心的手机控制之上提供更多个性化的技术应用，西安奥创软件研究院保留原西安总部，将核心技术研发部门搬迁 至上海闵行区，在这里不断发展壮大，为更多行业更多领域提供先进的技术解决方案。
        </p>
        <p class="text">
我们在网站群管理、智能文章生成、客服聊天系统、移动营销风控系统、电脑批量控制手机、图文生成视频、新媒体营销等领域都有深入研究，多年来专注技术研发，积累 了大量的项目开发经验，并且得到大家的广泛认可。
        </p>
      </div>
      <div class="icon-images pc">
        <div class="icon icon-left" @click="schoolLeft"></div>
        <div class="images-wrap">
          <div ref="listWrap" class="list-wrap" :class="['school_1','school_2','school_3'][schoolIndex-1]">
            <div class="images one">
              <img class="img" src="./image/us_banner_1.png" alt="">
              <img class="img" src="./image/us_banner_2.png" alt="">
            </div>
            <div class="images two">
              <img class="img" src="./image/us_banner_2.png" alt="">
              <img class="img" src="./image/us_banner_1.png" alt="">
            </div>
            <div class="images three">
              <img class="img" src="./image/us_banner_1.png" alt="">
              <img class="img" src="./image/us_banner_2.png" alt="">
            </div>
          </div>
        </div>
        <div class="icon icon-right" @click="schoolRight"></div>
      </div>
      <div class="icon-images phone">
        <img src="./image/us_banner_1.png" alt="" width="100%">
      </div>
    </div>
    <!-- 企业文化 -->
    <div class="culture-wrap">
      <div class="culture">
        <div class="img">
          <img src="./image/us_mission.png" alt="">
        </div>
        <div class="culture-text">
          <div class="title">企业使命</div>
          <div class="">用科技让运营变简单</div>
        </div>
      </div>
      <div class="line"></div>
      <div class="culture">
        <div class="img">
          <img src="./image/us_vision.png" alt="">
        </div>
        <div class="culture-text">
          <div class="title">企业愿景</div>
          <div class="">用代码改变世界</div>
        </div>
      </div>
      <div class="line"></div>
      <div class="culture">
        <div class="img">
          <img src="./image/us_value.png" alt="">
        </div>
        <div class="culture-text">
          <div class="title">企业价值观</div>
          <div class="">心怀感恩，诚信负责，成就客户</div>
        </div>
      </div>
    </div>
    <!-- 企业历史 -->
    <div class="ac-history">
      <div class="content-wrap">
        <div class="title">我们的发展历程</div>
        <div class="info">奥创软件研究院是专业的微信营销系统供应商，拥有强大的技术研发和服务团队，致力于为企业客户提供微信营销、管理、软硬件一站式解决方案。集客资留存、提升人效、风险管控、数据统计于一体，聚焦微信生态，推动行业发展，帮助企业实现业绩倍增。</div>
        <div class="company">
          <div class="block">
            <span class="text1">2001</span><span class="text2">年</span><span class="text3">公司成立</span>
          </div>
          <div class="line"></div>
          <div class="block">
            <span class="text1">106</span><span class="text2 add">+</span><span class="text3">覆盖城市</span>
          </div>
          <div class="line"></div>
          <div class="block">
            <span class="text1">13</span><span class="text2 add">+</span><span class="text3">项目研究成果</span>
          </div>
        </div>
        <!--<div class="product-show">
          <div class="icon icon-left" @click="productLeft"></div>
          <div class="product-wrap">
            <div class="product-list" :class="['product_1','product_2','product_3', 'product_4', 'product_5', 'product_6', 'product_7'][productIndex-1]">
              <div class="product">
                <img class="img" src="./image/us_dev.png" alt="">
                <div class="product-content-wrap">
                  <div class="text-title">站群管理系统</div>
                  <div class="content">通过搜索引擎自然优化规则进行推广，助力企业从搜索引擎端端获取到最大规模的流量，通过良好的商业模式，实现盈利</div>
                </div>
              </div>
              <div class="product">
                <img class="img" src="./image/us_dev.png" alt="">
                <div class="product-content-wrap">
                  <div class="text-title">群控系统</div>
                  <div class="content">群控系统可以进行批量手机系统操作，进行营销。极大的节省人工成本，助力微信营销效益达到最大化</div>
                </div>
              </div>
              <div class="product">
                <img class="img" src="./image/us_dev.png" alt="">
                <div class="product-content-wrap">
                  <div class="text-title">微信客服系统</div>
                  <div class="content">保障客户每分每秒及时沟通，为客户与用户提供沟通的最佳桥梁，是专业的企业级员工行为和员工微信管理的系统工具</div>
                </div>
              </div>
              <div class="product">
                <img class="img" src="./image/us_dev.png" alt="">
                <div class="product-content-wrap">
                  <div class="text-title">灵灵狗系统</div>
                  <div class="content">企业办公风控管控平台，帮助企业降低风险顺势，能有效管理公司销售或个人微信号，杜绝员工飞单、带走客户</div>
                </div>
              </div>
              <div class="product">
                <img class="img" src="./image/us_dev.png" alt="">
                <div class="product-content-wrap">
                  <div class="text-title">电话录音系统</div>
                  <div class="content">通话录音系统为客户提供对指定手机的呼入和呼出通话进行实时记录，以便管理者进行查询、管理</div>
                </div>
              </div>
              <div class="product">
                <img class="img" src="./image/us_dev.png" alt="">
                <div class="product-content-wrap">
                  <div class="text-title">短信备份系统</div>
                  <div class="content">短信备份系统为客户提供对指定手机的短信进行实时备份的功能，防止主要短信被误删，可严防企业员工删除敏感短信</div>
                </div>
              </div>
              <div class="product">
                <img class="img" src="./image/us_dev.png" alt="">
                <div class="product-content-wrap">
                  <div class="text-title">工作手机系统</div>
                  <div class="content">奥创工作手机为企业有效防止:员工飞单，恶意删除好友，客户转化率低，带走公司手机，删除聊天记录，工作量无法统计，等不安全因素</div>
                </div>
              </div>
              <div class="product phone">
                <img class="img" src="./image/us_dev.png" alt="">
                <div class="product-content-wrap">
                  <div class="text-title">站群管理系统</div>
                  <div class="content">通过搜索引擎自然优化规则进行推广，助力企业从搜索引擎端端获取到最大规模的流量，通过良好的商业模式，实现盈利</div>
                </div>
              </div>
            </div>
          </div>
          <div class="icon icon-right" @click="productRight"></div>
        </div>
        <div class="product-time-line">
          <div class="time-line-list">
            <div class="time-product"
                 @click="productIndex = n"
                 :class="{active: n === productIndex}"
                 v-for="n in 8"
                 :key="n">
              <span class="time-text">{{['16年前','16.05','17.05','17.11','17.12','18.01','18.03', '16年前'][n-1]}}</span>
              <span class="line-circle">
            <span class="circle"></span>
          </span>
              <span class="text-content">{{['站群管理系统','群控系统','微信客服系统','灵灵狗系统','电话录音系统','短信备份系统','工作手机系统', '站群管理系统'][n-1]}}</span>
            </div>
          </div>
        </div>-->
      </div>
    </div>
    <!-- 奥创资质 -->
    <div class="ac-aptitude">
      <div class="title-wrap">
        <div class="text-wrap">
          <div class="aptitude-title-wrap">
            <span class="aptitude-title">奥创资质</span>
            <span class="icon"></span>
          </div>
          <div class="text-content">公安部信息安全产品检测中心权威认证</div>
        </div>
        <div class="icon-wrap">
          <span class="icon icon-left" @click="aptitudeIndex = 1"></span>
          <span class="icon icon-right" @click="aptitudeIndex = 2"></span>
        </div>
      </div>
      <div class="images-wrap pc">
        <div class="image-list-wrap" :class="'imageIndex_'+aptitudeIndex">
          <div class="img-wrap">
            <img class="img" src="./image/us_qualification1.jpg" alt="">
          </div>
          <div class="img-wrap">
            <img class="img" src="./image/us_qualification2.jpg" alt="">
          </div>
          <div class="img-wrap">
            <img class="img" src="./image/us_qualification3.jpg" alt="">
          </div>
          <div class="img-wrap">
            <img class="img" src="./image/us_qualification4.jpg" alt="">
          </div>
          <div class="img-wrap">
            <img class="img" src="./image/us_qualification5.jpg" alt="">
          </div>
          <div class="img-wrap">
            <img class="img" src="./image/us_qualification6.jpg" alt="">
          </div>
        </div>
      </div>
      <div class="images-wrap phone">
        <div class="image-list-wrap" :class="'imageIndex_'+aptitudeIndex">
          <div class="img-wrap">
            <img class="img" src="./image/us_qualification1.jpg" alt="">
          </div>
          <div class="img-wrap">
            <img class="img" src="./image/us_qualification2.jpg" alt="">
          </div>
          <div class="img-wrap">
            <img class="img" src="./image/us_qualification3.jpg" alt="">
          </div>
          <div class="img-wrap">
            <img class="img" src="./image/us_qualification4.jpg" alt="">
          </div>
          <div class="img-wrap">
            <img class="img" src="./image/us_qualification5.jpg" alt="">
          </div>
          <div class="img-wrap">
            <img class="img" src="./image/us_qualification6.jpg" alt="">
          </div>
          <div class="img-wrap">
            <img class="img" src="./image/us_qualification1.jpg" alt="">
          </div>
        </div>
      </div>
      <div class="foot-line">
        <span class="line line1"></span>
        <span class="line line2"></span>
        <span class="line line3"></span>
      </div>
    </div>
  </div>
</template>

<script>
import Index from './main'

export default {
  name: 'about',
  ...Index
}
</script>
<style lang="scss">
  @import "./index";
</style>
